import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { type ClipVideoTaskMetadata } from '~/components/VideoClipTasks/types';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type VideoClipTaskPanelItemInProgressProps = {
  metadata: ClipVideoTaskMetadata;
  onCancel: () => void;
};

export const VideoClipTaskPanelItemInProgress = memo(
  ({ metadata, onCancel }: VideoClipTaskPanelItemInProgressProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const classicTitle =
      metadata?.saveResultAs?.as === 'assetVersion' ? 'Saving video as new version' : 'Saving as new video';
    const inProgressTitle = ui2026 ? 'Saving clip' : classicTitle;

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="VIDEO_CLIP_PANEL_IN_PROGRESS_TITLE">
            {ui2026 ? `${inProgressTitle}…` : inProgressTitle}
          </FileStatusTitle>
        }
        subtitle={
          ui2026 ? undefined : <FileStatusSubtitle className="truncate">Processing video...</FileStatusSubtitle>
        }
        buttons={<TaskPaneDismissButton label="Cancel" onClick={onCancel} />}
      />
    );
  },
);

VideoClipTaskPanelItemInProgress.displayName = 'VideoClipTaskPanelItemInProgress';
